import React, { useState, useEffect } from "react";
import { usePost } from "../../customHooks/usePost";
import { useGet } from "../../customHooks/useGet";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPlusCircle, FaTimesCircle } from "react-icons/fa";

function UserForm({ setShowForm, updateUsers }) {
  const [newUser, setNewUser] = useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    telephone: "",
    password: "",
    address: "",
    city: "",
    province: "",
    postalCode: "",
    role: "",
  });

  const { data: provincesData, loading: provincesLoading, error: provincesError } = useGet(
    "https://ectech-software.com.ar/api/core/provinces?page=0&size=5000"
  );

  const { data: rolesData, loading: rolesLoading, error: rolesError } = useGet(
    "https://ectech-software.com.ar/api/core/roles?page=0&size=50"
  );

  const [citiesUrl, setCitiesUrl] = useState(null);
  const { data: citiesData, loading: citiesLoading, error: citiesError } = useGet(citiesUrl);

  const { executePost, error: postError, loading: postLoading } = usePost();

  useEffect(() => {
    if (newUser.province) {
      setCitiesUrl(`https://ectech-software.com.ar/api/core/provinces/${newUser.province}/cities?page=0&size=5000`);
    } else {
      setCitiesUrl(null);
    }
  }, [newUser.province]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prevUser) => ({
      ...prevUser,
      [name]: value,
      ...(name === "province" ? { city: "" } : {}), // Resetear ciudad al cambiar provincia
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    

    const selectedCityId = citiesData?.content?.find(city => city.name === newUser.city)?.id;

    const userPayload = {
      username: newUser.username,
      password: newUser.password,
      status: true,
      userData: {
        name: newUser.firstName,
        lastname: newUser.lastName,
        email: newUser.email,
        telephone: newUser.telephone,
        address: newUser.address,
        postalCode: newUser.postalCode,
        locality: {
          id: selectedCityId,
        },
        role: newUser.role,
      },
    };

    try {
      const response = await executePost('https://ectech-software.com.ar/api/core/users?page=0&size=300', userPayload);
      if (response) {
        const createdUser = {
          id: response.id,
          username: response.username,
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          telephone: newUser.telephone,
          address: newUser.address,
          postalCode: newUser.postalCode,
          city: newUser.city,
          province: newUser.province,
          role: newUser.role,
        };
        updateUsers(createdUser);
        setShowForm(false);
      }
    } catch (err) {
      console.error('Error al crear el usuario:', err);
      alert(`Error al crear el usuario: ${err.message}`);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-primary text-white text-center">
          <h5 className="mb-0">Nuevo Usuario</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-floating mb-3">
              <input
                type="text"
                id="username"
                name="username"
                value={newUser.username}
                onChange={handleChange}
                className="form-control"
                required
              />
              <label htmlFor="username">Nombre de usuario</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="password"
                id="password"
                name="password"
                value={newUser.password}
                onChange={handleChange}
                className="form-control"
                required
              />
              <label htmlFor="password">Contraseña</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={newUser.firstName}
                onChange={handleChange}
                className="form-control"
                required
              />
              <label htmlFor="firstName">Nombre</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={newUser.lastName}
                onChange={handleChange}
                className="form-control"
                required
              />
              <label htmlFor="lastName">Apellido</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="email"
                id="email"
                name="email"
                value={newUser.email}
                onChange={handleChange}
                className="form-control"
                required
              />
              <label htmlFor="email">Correo electrónico</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                id="telephone"
                name="telephone"
                value={newUser.telephone}
                onChange={handleChange}
                className="form-control"
                required
              />
              <label htmlFor="telephone">Teléfono</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                id="address"
                name="address"
                value={newUser.address}
                onChange={handleChange}
                className="form-control"
                required
              />
              <label htmlFor="address">Dirección</label>
            </div>

            <div className="mb-3">
              <label className="form-label">Provincia:</label>
              {provincesLoading && <p>Cargando provincias...</p>}
              {provincesError && <p>Error al cargar provincias: {provincesError.message}</p>}
              {!provincesLoading && !provincesError && provincesData && (
                <select
                  name="province"
                  value={newUser.province}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="">Seleccionar provincia</option>
                  {Array.isArray(provincesData?.content) &&
                    provincesData.content.map((province) => (
                      <option key={province.id} value={province.id}>
                        {province.name}
                      </option>
                    ))}
                </select>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Ciudad:</label>
              {newUser.province ? (
                citiesLoading ? (
                  <p>Cargando ciudades...</p>
                ) : citiesError ? (
                  <p>Error al cargar ciudades</p>
                ) : Array.isArray(citiesData?.content) && citiesData.content.length > 0 ? (
                  <select
                    name="city"
                    value={newUser.city}
                    onChange={handleChange}
                    className="form-select"
                    required
                  >
                    <option value="">Seleccionar ciudad</option>
                    {citiesData.content.map((city) => (
                      <option key={city.id} value={city.name}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <p>No hay ciudades disponibles</p>
                )
              ) : (
                <p>Seleccione una provincia primero</p>
              )}
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                id="postalCode"
                name="postalCode"
                value={newUser.postalCode}
                onChange={handleChange}
                className="form-control"
              />
              <label htmlFor="postalCode">Código Postal</label>
            </div>

            <div className="mb-3">
              <label className="form-label">Rol:</label>
              {rolesLoading && <p>Cargando roles...</p>}
              {rolesError && <p>Error al cargar roles: {rolesError.message}</p>}
              {!rolesLoading && !rolesError && rolesData && (
                <select
                  name="role"
                  value={newUser.role}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="">Seleccionar rol</option>
                  {Array.isArray(rolesData?.content) &&
                    rolesData.content.map((role) => (
                      <option key={role.id} value={role.name}>
                        {role.name}
                      </option>
                    ))}
                </select>
              )}
            </div>

            <div className="d-flex gap-2">
              <button type="submit" disabled={postLoading} className="btn btn-primary w-50">
                {postLoading ? "Creando Usuario..." : "Crear Usuario"} <FaPlusCircle className="ms-2" />
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary w-50"
                onClick={() => setShowForm(false)}
              >
                Cancelar <FaTimesCircle className="ms-2" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UserForm;
